import React, { useEffect, useRef } from 'react';
import { createAndResizeCircImgDivs } from '../scripts/resizer';

const Modal = ({ id, title, content, imageSrc, onClose }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        const currModal = modalRef.current;
        const modalWidth = "82%";
        const modalHeight = "74%";

        // Set size parameters based on percentages
        const htOffset = ((100 - Number(modalHeight.slice(0, -1))) / 2) + "%";
        const modalContent = currModal.querySelector('.hdr-modal-window > div');
        modalContent.style.maxHeight = modalHeight;
        modalContent.style.left = ((100 - Number(modalWidth.slice(0, -1))) / 2) + "%";
        modalContent.style.top = htOffset;
        modalContent.style.width = modalWidth;

        // Set accessibility attributes
        currModal.setAttribute("role", "dialog");
        currModal.setAttribute("aria-modal", "true");
        currModal.setAttribute("aria-labelledby", `${id}-title`);
        currModal.setAttribute("aria-describedby", `${id}-desc`);

        const modalTitle = currModal.querySelector(".hdr-modal-title");
        modalTitle.setAttribute("id", `${id}-title`);
        const modalDesc = currModal.querySelector(".hdr-modal-body p");
        if (modalDesc) {
            modalDesc.setAttribute("id", `${id}-desc`);
        }

        // Set click & keyboard functionality on close modal button
        const closeModalButton = currModal.querySelector(".hdr-modal-window > div .hdr-close-modal");
        closeModalButton.style.display = "block";
        closeModalButton.addEventListener("click", onClose);
        closeModalButton.addEventListener("keydown", (evt) => {
            if (evt.key === "Enter" || evt.key === " ") {
                onClose();
            }
        });

        // Restrict tabbing out of modal window while open
        const focusableElements = currModal.querySelectorAll("a, button, input, textarea, select, details, [tabindex]:not([tabindex='-1'])");
        currModal.addEventListener("keydown", (evt) => {
            const which = evt.keyCode || evt.which;
            if (which === 9) {
                if (evt.shiftKey) {
                    if (document.activeElement === focusableElements[0]) {
                        evt.preventDefault();
                    }
                } else {
                    if (document.activeElement === focusableElements[focusableElements.length - 1]) {
                        evt.preventDefault();
                    }
                }
            }

            if (which === 27) { // Close if Escape key pressed
                closeModalButton.click();
            }
        });

        // Apply resizing logic after modal content is rendered
        createAndResizeCircImgDivs(currModal);
    }, [id, onClose]);

    return (
        <div id={id} className="hdr-modal hdr-modal-window" ref={modalRef}>
            <button className="hdr-close-modal" onClick={onClose}><span>Close modal window</span></button>
            <div>
                <button className="hdr-close-modal" onClick={onClose}>
                    <div aria-hidden="true">&times;</div>
                    <span>Close modal window</span>
                </button>
                <div className="hdr-modal-title-area" style={{backgroundImage: `url(${imageSrc})`}}>
                    <h2 className="hdr-modal-title">{title}</h2>
                </div>
                {content}
            </div>
        </div>
    );
};

export default Modal;
